import { Link } from 'react-router-dom';
import BrandLogo from '@/components/common/BrandLogo';
import LanguageMenu from '@/components/common/LanguageMenu';
import { AUTH_ICON_BTN } from './authStyles';

interface Props { subtitle: string; homeLabel: string; plain?: boolean }

export default function AuthHeader({ subtitle, homeLabel, plain = true }: Props) {
  return (
    <header className={`w-full px-5 lg:px-10 py-3 flex items-center justify-between sticky top-0 z-30 ${plain ? '' : 'bg-white/80 backdrop-blur-md border-b border-neutral-200/70'}`}>
      <Link to="/" className="flex items-center gap-2 group">
        <BrandLogo className="w-7 h-7 group-hover:scale-105 transition-transform" />
        <div className="flex flex-col">
          <span className="font-extrabold text-sm leading-tight tracking-tight text-neutral-900">LoyaltyBridge</span>
          <span className="text-[9px] text-neutral-600 font-medium">{subtitle}</span>
        </div>
      </Link>
      <div className="flex items-center gap-2">
        <LanguageMenu />
        <Link to="/" aria-label={homeLabel} title={homeLabel} className={AUTH_ICON_BTN}>
          <i className="ri-arrow-left-line text-xl leading-none" aria-hidden="true" />
        </Link>
      </div>
    </header>
  );
}
